import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/**
 * Settings > Securitee > AbuseIPDB (`SettingsSecuriteeAbuseIpdbController`).
 * Cheia nu vine niciodata inapoi: numai `key_set`. Orele sunt UTC.
 */

export type AbuseIpdbSetting = {
  key_set: boolean
  enabled: boolean
  enabled_at: string | null
  /** pornit, dar ph4 numai noteaza ce ar fi blocat */
  report_only: boolean
  /** IP-urile de la 20% se raporteaza in AbuseIPDB, public, cu cheia firmei */
  report_enabled: boolean
  allowlist: string
  checked_at: string | null
  check_ok: boolean | null
  check_error: string | null
  checks_left: number | null
  paused_until: string | null
}

export type AbuseIpdbPage = {
  canWrite: boolean
  cryptoReady: boolean
  ready: boolean
  /** treptele lui ph4: de la `from`% la `to`%, blocat `minutes` (null = numai notat) */
  tiers: { from: number; to: number; minutes: number | null }[]
  rules: { id: string; label: string }[]
  setting: AbuseIpdbSetting | null
}

export type AbuseIpdbForm = { api_key: string; enabled: boolean; report_only: boolean; report_enabled: boolean; allowlist: string }

export const ABUSEIPDB_KEY = ['settings', 'securitee', 'abuseipdb'] as const

export function abuseIpdbPageQuery() {
  return queryOptions({
    queryKey: ABUSEIPDB_KEY,
    queryFn: () => apiGet<AbuseIpdbPage>('/settings/securitee/abuseipdb'),
  })
}

export function abuseIpdbSave(form: AbuseIpdbForm): Promise<AbuseIpdbPage> {
  return apiPost<AbuseIpdbPage>('/settings/securitee/abuseipdb', form)
}

export function abuseIpdbTest(): Promise<{ ok: boolean; checks_left: number | null; error?: string }> {
  return apiPost('/settings/securitee/abuseipdb/test', {})
}

export function abuseIpdbDelete(): Promise<AbuseIpdbPage> {
  return apiPost<AbuseIpdbPage>('/settings/securitee/abuseipdb/delete', {})
}

/** Un rand din "Activity": o detectie verificata de ph4 (orele UTC). */
export type AbuseIpdbCheck = {
  id: number
  checked_at: string
  device_id: number
  device_name: string
  rule_id: string
  ip: string | null
  country: string | null
  score: number | null
  reports: number | null
  /** `gateway`: RADIUS / VPN, de blocat pe gateway-ul VPN (un BIP pe NPS n-ar opri nimic) */
  outcome: 'blocked' | 'would_block' | 'gateway' | 'noted' | 'below' | 'allowlisted' | 'own_ip' | 'not_public' | 'no_ip' | 'already' | 'error' | 'paused'
  error: string | null
  /** numai la `blocked`: activa, ridicata de UIP-ul lui ph4, sau de un om */
  state: 'active' | 'auto_unblocked' | 'hand_unblocked' | null
  /** la `blocked` / `would_block`: cat tine treapta scorului */
  block_minutes: number | null
  unblock_due: string | null
  unblocked_at: string | null
  /** raportat in AbuseIPDB (UTC), sau de ce l-a refuzat; lipsesc inainte de migrare */
  reported_at?: string | null
  report_error?: string | null
  incident_id: number | null
  ticket_id: number | null
  /** un rand pe IP si aparat in 24h: de cate ori a venit IP-ul si cand ultima oara (UTC) */
  seen?: number
  last_seen_at?: string | null
}

/** `internal`: verificarile cu adresa interna sau lipsa, numarate, nu listate */
export type AbuseIpdbActivity = { all: boolean; days: number; counts: { blocked: number; would_block: number; gateway?: number; noted: number; checked: number; internal?: number }; rows: AbuseIpdbCheck[] }

export function abuseIpdbActivityQuery(all: boolean) {
  return queryOptions({
    queryKey: [...ABUSEIPDB_KEY, 'activity', all],
    queryFn: () => apiGet<AbuseIpdbActivity>('/settings/securitee/abuseipdb/activity' + (all ? '?all=1' : '')),
  })
}
